import React, { useEffect, useState } from 'react';
import {
  Button,
  CardTitle,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { environment } from '../../api/api_urls';
import constants from '../../api/api_urls';
import { apiDelete, apiGet, apiPostPut } from '../../api/api_methods';
import { ADMIN_ENDPOINTS } from '../../api/api_endpoints';

const Blogs = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [editedBlog, setEditedBlog] = useState({
    title: '',
    category: '',
    author: '',
    htmlContent: '',
    featuredImage: '',
  });
  const [load, setLoad] = useState(false);
  useEffect(() => {
    fetchBlogs();
  }, []);

  const fetchBlogs = async () => {
    const response = await apiGet(ADMIN_ENDPOINTS.BLOGS_GET_ALL);
    if (response.status === 200) {
      const list = response.body?.data ?? response.body;
      setBlogs(Array.isArray(list) ? list : []);
    } else {
      console.error('Error fetching blogs: ', response.body);
    }
  };

  // Open Edit Modal
  const handleEdit = (blog) => {
    setSelectedBlog(blog);
    setEditedBlog({
      title: blog.title,
      category: blog.category,
      author: blog.author.name,
      htmlContent: blog.htmlContent,
      featuredImage: blog.featuredImage,
    });
    setIsModalOpen(true);
  };

  // Save Changes and Update API
  const handleSave = async () => {
    if (!selectedBlog) return;

    const baseUrl =
      constants.environment === 'prod'
        ? constants.prodUrl
        : constants.environment === 'qa'
          ? constants.qaUrl
          : constants.futureUrl;

    const updatedBlog = { ...selectedBlog, ...editedBlog };

    const response = await apiPostPut(
      updatedBlog,
      ADMIN_ENDPOINTS.BLOGS_EDIT_BY_ID(selectedBlog._id),
      'PUT',
    );
    if (response.status === 200) {
      fetchBlogs();
      setIsModalOpen(false);
    } else {
      console.error('Error updating blog: ', response.body);
    }
  };

  // Delete Blog
  const handleDelete = async (id) => {
    const confirmed = window.confirm('Are you sure you want to delete this blog?');
    if (!confirmed) return;
    setLoad(true);

    const response = await apiDelete(ADMIN_ENDPOINTS.BLOGS_DELETE_BY_ID(id));
    if (response.status === 200) {
      fetchBlogs();
    } else {
      console.error('Error deleting blog: ', response.body);
    }
    setLoad(false);
  };

  return (
    <div className="container mt-5">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <CardTitle tag="h4">Blogs</CardTitle>
        <Button color="primary" onClick={() => navigate(`/${environment}/dashboards/blogs2`)}>
          <i className="bi bi-plus-circle"></i> Create New Blog
        </Button>
      </div>

      <div className="table-responsive">
        <Table className="text-nowrap align-middle mb-0" hover>
          <thead>
            <tr className="text-center">
              <th>Title</th>
              <th>Image</th>
              <th>Category</th>
              <th>Author</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {blogs?.data?.length > 0 ? (
              blogs.data.map((blog) => (
                <tr key={blog._id} className="border-top text-center">
                  <td>
                    {blog.title.length > 20 ? blog.title.substring(0, 20) + '...' : blog.title}
                  </td>
                  <td>
                    <img
                      src={blog.featuredImage}
                      alt={blog.title}
                      width="50"
                      height="50"
                      className="rounded"
                    />
                  </td>
                  <td>{blog.category}</td>
                  <td>{blog.author.name}</td>
                  <td>
                    {blog.htmlContent.length > 50
                      ? blog.htmlContent.substring(0, 50) + '...'
                      : blog.htmlContent}
                  </td>
                  <td className="flex ">
                    <Button size="md" onClick={() => handleEdit(blog)}>
                      <i
                        style={{
                          fontSize: '15px',
                          color: 'black',
                          cursor: 'pointer',
                          transition: 'color 0.3s ease',
                        }}
                        onMouseEnter={(e) => (e.target.style.color = 'red')}
                        onMouseLeave={(e) => (e.target.style.color = 'black')}
                        className="bi bi-pencil-square"
                      ></i>
                    </Button>

                    <Button size="md" onClick={() => handleDelete(blog._id)}>
                      <i
                        style={{
                          fontSize: '15px',
                          color: 'black',
                          cursor: 'pointer',
                          transition: 'color 0.3s ease',
                        }}
                        onMouseEnter={(e) => (e.target.style.color = 'red')}
                        onMouseLeave={(e) => (e.target.style.color = 'black')}
                        className="bi bi-trash3"
                      ></i>
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No blogs found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      {/* Edit Modal */}
      <Modal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(false)}
        className="modal-dialog-centered"
      >
        <ModalHeader toggle={() => setIsModalOpen(false)}>Edit Blog</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label>Title</Label>
              <Input
                type="text"
                value={editedBlog.title}
                onChange={(e) => setEditedBlog({ ...editedBlog, title: e.target.value })}
              />
            </FormGroup>

            <FormGroup>
              <Label>Category</Label>
              <Input
                type="text"
                value={editedBlog.category}
                onChange={(e) => setEditedBlog({ ...editedBlog, category: e.target.value })}
              />
            </FormGroup>

            <FormGroup>
              <Label>Author</Label>
              <Input
                type="text"
                value={editedBlog.author}
                onChange={(e) => setEditedBlog({ ...editedBlog, author: e.target.value })}
              />
            </FormGroup>

            <FormGroup>
              <Label>Description</Label>
              <Input
                type="textarea"
                value={editedBlog.htmlContent}
                onChange={(e) => setEditedBlog({ ...editedBlog, htmlContent: e.target.value })}
              />
            </FormGroup>

            <FormGroup>
              <Label>Image URL</Label>
              <Input
                type="text"
                value={editedBlog.featuredImage}
                onChange={(e) => setEditedBlog({ ...editedBlog, featuredImage: e.target.value })}
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSave}>
            Save Changes
          </Button>
          <Button color="secondary" onClick={() => setIsModalOpen(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default Blogs;
